export enum PopoverAttachmentType {
    FULL = 'full',
    VERTICAL = 'vertical',
    HORIZONTAL = 'horizontal'
}

export enum PopoverHeightRestriction {
    NONE                = 'none',
    WINDOW_HEIGHT       = 'window-height',
    HALF_WINDOW_HEIGHT  = 'half-window-height'
}

// export enum PopoverTargetAttachment {
//     BOTTOM_LEFT = "bottom left",
// }


